var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside.includeChildrens",
          value: _vm.closeTips,
          expression: "closeTips",
          modifiers: { includeChildrens: true }
        }
      ],
      staticClass: "v-search-tips"
    },
    [
      _c("div", { staticClass: "search-input-container" }, [
        _c("img", {
          staticClass: "search-icon",
          attrs: { src: require("assets/imgs/search_gray.png") }
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.userInput,
              expression: "userInput"
            }
          ],
          staticClass: "search-input",
          attrs: { type: "text" },
          domProps: { value: _vm.userInput },
          on: {
            blur: function($event) {
              return _vm.search(_vm.userInput)
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.userInput = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShowTips,
              expression: "isShowTips"
            }
          ],
          staticClass: "tips-list"
        },
        _vm._l(_vm.searchRes, function(item) {
          return _c(
            "div",
            {
              key: item.id,
              staticClass: "tips-item __pointer",
              on: {
                click: function($event) {
                  return _vm.selected(item)
                }
              }
            },
            [_vm._v("\n            " + _vm._s(item.name) + "\n        ")]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }